module.exports = __webpack_public_path__ + "2abd831264886f960dba742e92f43c8e.MP3";